/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidInvoiceReissue200,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceReissue400,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceReissue401,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceReissue500,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceReissueMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceReissuePathParams,
} from "../../types/individualPaymentInvoicesController/PostApiV1IndividualpaymentParcelsParcelidInvoiceReissue.ts";

export const postApiV1IndividualpaymentParcelsParcelidInvoiceReissuePathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceReissuePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceReissue200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceReissue200>;

/**
 * @description Regra de negócio violada / eNotas fora de escopo
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceReissue400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceReissue400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceReissue401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceReissue401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceReissue500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceReissue500>;

export const postApiV1IndividualpaymentParcelsParcelidInvoiceReissueMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsParcelidInvoiceReissue200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceReissueMutationResponse>;
